var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBatteryOrangeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0255 2.07581H8.11769C4.81125 2.07581 2.13086 4.55471 2.13086 7.6126V29.7598C2.13086 32.8177 4.81125 35.2966 8.11769 35.2966H50.0255C53.3319 35.2966 56.0123 32.8177 56.0123 29.7598V7.6126C56.0123 4.55471 53.3319 2.07581 50.0255 2.07581Z",
    stroke: "url(#paint0_linear_35046_643)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2701 10.3787L23.0859 18.6839H35.0596L27.8754 26.989M56.0135 13.1471H60.5036C60.9006 13.1471 61.2813 13.2929 61.5619 13.5525C61.8426 13.8121 62.0003 14.1641 62.0003 14.5313V22.8364C62.0003 23.2036 61.8426 23.5556 61.5619 23.8152C61.2813 24.0748 60.9006 24.2206 60.5036 24.2206H56.0135V13.1471Z",
    stroke: "url(#paint1_linear_35046_643)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35046_643",
    x1: 42.0776,
    y1: 10.6282,
    x2: 17.1001,
    y2: 62.2644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35046_643",
    x1: 51.9364,
    y1: 14.6549,
    x2: 42.3431,
    y2: 43.3014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryOrangeIcon);
export default __webpack_public_path__ + "static/media/battery_orange_icon.ac622adee9ba92a7a68ff3be0bf996bf.svg";
export { ForwardRef as ReactComponent };